(function () {
  var root = document.querySelector('[data-ti-signs]');
  if (!root) return;
  var dataEl = document.querySelector('[data-ti-signs-data]');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  DATA.variants = [];

  // Quote settings come from the section (rendered into data attributes by the section).
  // Optional H-stakes are charged as separate Shopify pack items.
  var QUOTE_URL = root.getAttribute('data-quote-url') || '/pages/quote-upload';

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // ---- Sides / Colors lookup, derived from the product's real combined values ----
  // Product option "Printing Options" holds values like "1 Sided - 1 Color".
  // We split on the FIRST " - " so color values containing hyphens (rare) still work.
  var SIDES = [];      // ordered unique sides, e.g. ["1 Sided", "2 Sided"]
  var COLORS = [];     // ordered unique colors, e.g. ["1 Color", ... , "Full Color Digitized"]
  var COMBO = {};      // "sides|colors" -> exact original combined value

  function splitCombined(val) {
    var i = val.indexOf(' - ');
    if (i === -1) return null;
    return { sides: val.slice(0, i).trim(), colors: val.slice(i + 3).trim() };
  }
  function buildLookup() {
    (DATA.prints || []).forEach(function (val) {
      var parts = splitCombined(val);
      if (!parts) return;
      if (SIDES.indexOf(parts.sides) === -1) SIDES.push(parts.sides);
      if (COLORS.indexOf(parts.colors) === -1) COLORS.push(parts.colors);
      COMBO[parts.sides + '|' + parts.colors] = val;
    });
    // Keep "Full Color Digitized" visually last — it's a different process, not "5 colors".
    COLORS.sort(function (a, b) {
      var fa = /full color/i.test(a) ? 1 : 0, fb = /full color/i.test(b) ? 1 : 0;
      if (fa !== fb) return fa - fb;
      return 0;
    });
  }
  function combinedValue() {
    if (!state.sides || !state.colors) return null;
    return COMBO[state.sides + '|' + state.colors] || null;
  }
  function sidesCount() { return /2/.test(state.sides || '') ? 2 : 1; }
  function isFullColor(c) { return /full color/i.test(c || ''); }

  // ---- State ---- step 0 Ordering·1 Size·2 Sides·3 Colors·4 Quantity·5 Finishing·6 Artwork·7 Review
  var LAST_STEP = 7;
  var furthest = 0;       // #2 furthest step reached — completed steps stay clickable
  var state = {
    step: 0,
    path: null,           // 'standard' | 'quote'
    size: null,
    sides: null,
    colors: null,
    qty: 0,
    finishing: [],
    stakes: 0,
    sameArtwork: false,
    designHelp: false,    // #15 "I need help creating my design" → routes to quote
    artworkByside: {},    // 'Front' | 'Back' -> file name
    artworkFileBySide: {},
    notes: ''
  };
  var body = root.querySelector('[data-ti-body]');
  var stepsEl = root.querySelector('[data-ti-steps]');
  var backBtn = root.querySelector('[data-ti-back]');
  var nextBtn = root.querySelector('[data-ti-next]');
  var preview = root.querySelector('[data-ti-preview]');
  var estEl = root.querySelector('[data-ti-est]');

  // ---- Quantity-band pricing (data table from the section; NEVER computed) ----
  // pricingRaw is a JSON STRING (safely encoded via Liquid | json) → parse to
  // { "1 Sided - 1 Color": [{min,max,price}, ...], ... }  prices in dollars.
  var PRICING = {};
  try {
    var raw = DATA.pricingRaw;
    if (typeof raw === 'string' && raw.trim()) PRICING = JSON.parse(raw) || {};
    else if (raw && typeof raw === 'object') PRICING = raw;
  } catch (e) { PRICING = {}; }
  var MIN_SPOT = DATA.minSpot || 10, MIN_FULL = DATA.minFull || 5;
  var MAX_FULL = DATA.maxFull || 25, MAX_SPOT = DATA.maxSpot || 250;

  // Resolve the exact Shopify variant from the combined print value (signs have no size option).
  function variant() {
    var combined = combinedValue();
    if (!combined) return null;
    return DATA.variants.find(function (v) { return v.options.indexOf(combined) !== -1; });
  }
  // Unit price = the band whose [min,max] contains qty, looked up by the combined option value.
  // Returns cents, or null if no band matches (below min / above max / unknown combo).
  function unitPriceCents() {
    var combined = combinedValue();
    if (!combined) return null;
    var bands = PRICING[combined];
    if (!bands || !bands.length) return null;
    var q = state.qty || 0;
    for (var i = 0; i < bands.length; i++) {
      if (q >= bands[i].min && q <= bands[i].max) return Math.round(bands[i].price * 100);
    }
    return null; // out of band range → caller routes to quote
  }
  // A price only "counts" if there's no quote reason (e.g. spot>250 still matches the 250+ band,
  // but the client wants it quoted — so suppress the price and route to quote).
  function hasPrice() { var p = unitPriceCents(); return p != null && p > 0 && !quoteReason(); }
  function signsTotalCents() {
    if (quoteReason()) return 0;
    var p = unitPriceCents();
    if (p == null) return 0;
    return p * (state.qty || 0);
  }

  var STAKES = [0, 25, 50, 100, 150, 250];
  var STAKE_PACKS = {
    25: { id: 42831192686674, price: 2000 },
    50: { id: 42831192719442, price: 3600 }
  };
  function stakesPack() { return state.stakes === 25 ? STAKE_PACKS[25] : STAKE_PACKS[50]; }
  function stakesPacksCount() { return state.stakes === 25 ? 1 : state.stakes / 50; }
  function stakesTotalCents() { return state.stakes ? stakesPack().price * stakesPacksCount() : 0; }
  function orderTotalCents() { return signsTotalCents() + stakesTotalCents(); }
  function stakesDescription() { return state.stakes ? state.stakes + ' H-stakes (' + money(stakesTotalCents()) + ')' : 'None'; }

  // Why the order must go to a quote instead of checkout (spec #13). Returns a message or null.
  function quoteReason() {
    if (!state.colors) return null;
    var q = state.qty || 0;
    var full = isFullColor(state.colors);
    if (full && q > MAX_FULL) return 'For more than ' + MAX_FULL + ' full colour signs, let’s talk — we’ll get you a better price.';
    if (!full && q > MAX_SPOT) return 'For orders over ' + MAX_SPOT + ', let’s talk.';
    if (q > 0) {
      var min = full ? MIN_FULL : MIN_SPOT;
      if (q < min) return 'Our minimum is ' + min + ' signs. Get in touch and we’ll help.';
    }
    if (state.designHelp) return 'We’ll design it for you and send a price before anything is printed.';
    return null;
  }

  // #1 min/max for the current print method, and a clamp that snaps into range.
  function qtyBounds() {
    var full = isFullColor(state.colors);
    return { min: full ? MIN_FULL : MIN_SPOT, max: full ? MAX_FULL : MAX_SPOT, full: full };
  }
  function clampQty(q) {
    var b = qtyBounds();
    if (!q || q < b.min) return b.min;
    if (q > b.max) return b.max;
    return q;
  }
  // Quote URL with the current sign selections pre-filled (spec #1 max message link).
  function quotePrefillUrl() {
    var q = { product: DATA.productTitle || '', type: 'Custom sign', sides: state.sides || '',
      colors: state.colors || '', qty: state.qty || '' };
    var params = Object.keys(q).filter(function (k) { return q[k] !== '' && q[k] != null; })
      .map(function (k) { return k + '=' + encodeURIComponent(q[k]); }).join('&');
    return QUOTE_URL + (QUOTE_URL.indexOf('?') === -1 ? '?' : '&') + params;
  }
  // The at-min / at-max informational message shown on the Quantity step (spec #1). Returns HTML or ''.
  function qtyMessageHTML() {
    var b = qtyBounds(), q = state.qty || 0, url = quotePrefillUrl();
    if (q >= b.max) {
      if (b.full) return 'Full colour is available up to ' + b.max + ' signs. For larger full-colour runs, email <a href="mailto:order@thingsinked.com">order@thingsinked.com</a> and we’ll price it for you. <a href="' + url + '">Request a quote</a>';
      return 'Ordering ' + b.max + ' or more? Let’s talk. Large runs are priced individually so you get the best rate, and we’ll arrange freight shipping for you. <a href="' + url + '">Request a quote</a> or email <a href="mailto:order@thingsinked.com">order@thingsinked.com</a>';
    }
    if (q <= b.min) {
      return 'Our minimum is ' + b.min + ' signs. Need fewer? Email us at <a href="mailto:order@thingsinked.com">order@thingsinked.com</a> — we’ll see what we can do.';
    }
    return '';
  }
  function updateQtyNote() {
    var note = root.querySelector('[data-ti-qty-note]');
    if (!note) return;
    var msg = qtyMessageHTML();
    if (msg) { note.innerHTML = msg; note.hidden = false; } else { note.hidden = true; }
  }

  var SIDES_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/></svg>';

  function render() {
    if (state.step > furthest) furthest = state.step;
    // #2 Clickable step bar: any step up to the furthest reached (except current) is a button.
    Array.prototype.forEach.call(stepsEl.children, function (el, i) {
      var done = i < state.step, current = i === state.step, reachable = i <= furthest && !current;
      el.className = 'ti-cfg__step' + (current ? ' is-active' : '') + (done ? ' is-done' : '') + (reachable ? ' is-clickable' : '');
      if (current) { el.setAttribute('aria-current', 'step'); } else { el.removeAttribute('aria-current'); }
      el.setAttribute('aria-disabled', reachable ? 'false' : 'true');
      el.style.cursor = reachable ? 'pointer' : 'default';
    });
    var s = state.step, html = '';

    if (s === 0) {
      html = '<h2 class="ti-cfg__h">How would you like to order?</h2><p class="ti-cfg__hint">Most sign orders are self-service. Large or unusual jobs? A real person can help.</p>' +
        '<div class="ti-cfg__cards">' +
          '<div class="ti-cfg__card' + (state.path === 'standard' ? ' is-sel' : '') + '" data-path="standard">' +
            '<span class="ti-cfg__card-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
            '<span class="ti-cfg__card-badge">Fastest</span>' +
            '<p class="ti-cfg__card-t">Standard order</p>' +
            '<p class="ti-cfg__card-d">Configure it yourself and check out online. We send a free digital proof after payment — nothing prints until you approve.</p>' +
          '</div>' +
          '<div class="ti-cfg__card' + (state.path === 'quote' ? ' is-sel' : '') + '" data-path="quote">' +
            '<span class="ti-cfg__card-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>' +
            '<p class="ti-cfg__card-t">Complex order? Request a Quote</p>' +
            '<p class="ti-cfg__card-d">Big installs, unusual sizes, or bulk runs — talk to a real person who\'ll build the order with you.</p>' +
          '</div>' +
        '</div>';

    } else if (s === 1) {
      if (!DATA.sizes || !DATA.sizes.length) {
        html = '<h2 class="ti-cfg__h">Sign size</h2>' +
          '<div class="ti-cfg__note">Sizes for this sign are quoted individually. Continue and we\'ll confirm size and pricing on your quote.</div>';
      } else {
        html = '<h2 class="ti-cfg__h">Sign size</h2><p class="ti-cfg__hint">Pick the finished size of your sign.</p><div class="ti-cfg__opts">' +
          DATA.sizes.map(function (sz) {
            return '<div class="ti-cfg__opt' + (state.size === sz ? ' is-sel' : '') + '" data-size="' + sz.replace(/"/g, '&quot;') + '"><span class="ti-cfg__opt-name">' + sz + '</span></div>';
          }).join('') + '</div>';
      }

    } else if (s === 2) {
      html = '<h2 class="ti-cfg__h">Printed on one side or both?</h2><p class="ti-cfg__hint">This is the biggest driver of your price.</p><div class="ti-cfg__grid2">' +
        SIDES.map(function (sd) {
          var n = /2/.test(sd) ? 2 : 1;
          return '<div class="ti-cfg__card' + (state.sides === sd ? ' is-sel' : '') + '" data-sides="' + sd.replace(/"/g, '&quot;') + '">' +
            '<span class="ti-cfg__card-ic">' + SIDES_SVG + '</span>' +
            '<p class="ti-cfg__card-t">' + sd + '</p>' +
            '<p class="ti-cfg__card-d">' + (n === 2 ? 'Your design prints on the front and the back.' : 'Your design prints on the front only.') + '</p>' +
          '</div>';
        }).join('') + '</div>';

    } else if (s === 3) {
      html = '<h2 class="ti-cfg__h">How many colors are in your design?</h2><p class="ti-cfg__hint">Pick the number of ink colors — or full-color if your art is a photo or gradient.</p><div class="ti-cfg__opts">' +
        COLORS.map(function (c) {
          var avail = !!COMBO[(state.sides || SIDES[0]) + '|' + c];
          var sub = isFullColor(c) ? '<div class="ti-cfg__opt-sub">Photographic / gradient artwork — a different print process.</div>' : '';
          return '<div class="ti-cfg__opt' + (state.colors === c ? ' is-sel' : '') + (avail ? '' : ' is-disabled') + '" ' + (avail ? 'data-colors="' + c.replace(/"/g, '&quot;') + '"' : '') + '>' +
            '<span><span class="ti-cfg__opt-name">' + c + '</span>' + sub + '</span></div>';
        }).join('') + '</div>' +
        '<p class="ti-cfg__helper">Count the ink colors in your logo — not the colors of the sign.</p>';

    } else if (s === 4) {
      // #1 Clamped quantity. Limits change with print method (full colour caps at 25).
      var full = isFullColor(state.colors);
      var breaks = full ? [5, 10, 15, 25] : [10, 25, 50, 100, 150, 250];
      var minQ = full ? MIN_FULL : MIN_SPOT, maxQ = full ? MAX_FULL : MAX_SPOT;
      if (!state.qty) state.qty = minQ;   // field loads pre-filled at the minimum, not 0/empty
      var label = full
        ? 'Enter a quantity or pick a common amount. Minimum ' + minQ + ', maximum ' + maxQ + ' for full colour.'
        : 'Enter a quantity or pick a common amount. Minimum ' + minQ + ', maximum ' + maxQ + '.';
      html = '<h2 class="ti-cfg__h">How many signs?</h2><p class="ti-cfg__hint">' + label + '</p>' +
        '<div class="ti-cfg__qty-row"><input type="number" inputmode="numeric" min="' + minQ + '" max="' + maxQ + '" step="1" value="' + (state.qty || minQ) + '" data-ti-qty><span style="color:#8a93a0;font-size:0.9rem">signs</span></div>' +
        '<div class="ti-cfg__quickpicks">' +
        breaks.map(function (b) {
          return '<button type="button" class="ti-cfg__pick' + (state.qty === b ? ' is-sel' : '') + '" data-ti-pick="' + b + '">' + b + '</button>';
        }).join('') + '</div>' +
        '<div class="ti-cfg__note" data-ti-qty-note hidden></div>';

    } else if (s === 5) {
      html = '<h2 class="ti-cfg__h">H-Stakes</h2>' +
        '<p class="ti-cfg__hint" id="ti-stakes-label">How many H-stakes would you like?</p>' +
        '<div class="ti-cfg__quickpicks" role="group" aria-labelledby="ti-stakes-label">' +
        STAKES.map(function (q) {
          return '<button type="button" class="ti-cfg__pick' + (state.stakes === q ? ' is-sel' : '') + '" data-ti-stakes="' + q + '" aria-pressed="' + (state.stakes === q) + '">' + q + '</button>';
        }).join('') + '</div>';

    } else if (s === 6) {
      var n = sidesCount();
      html = '<h2 class="ti-cfg__h">Your artwork</h2><p class="ti-cfg__hint">We review every file and send a proof before printing.</p>' +
        '<div class="ti-cfg__checks" style="margin-bottom:1rem">' +
          '<label class="ti-cfg__check' + (!state.designHelp ? ' is-sel' : '') + '"><input type="radio" name="ti-artmode" data-ti-artmode="have"' + (!state.designHelp ? ' checked' : '') + '><span class="ti-cfg__check-name">I have print-ready artwork</span></label>' +
          '<label class="ti-cfg__check' + (state.designHelp ? ' is-sel' : '') + '"><input type="radio" name="ti-artmode" data-ti-artmode="help"' + (state.designHelp ? ' checked' : '') + '><span class="ti-cfg__check-name">I need help creating my design</span></label>' +
        '</div>';
      if (state.designHelp) {
        html += '<div class="ti-cfg__note">No problem — tell us what you need and we’ll design it for you. We’ll send you a price before anything is printed.</div>' +
          '<div class="ti-cfg__field"><label>Tell us about your design</label><textarea data-ti-notes rows="4" placeholder="Colours, logo, text, references…">' + (state.notes || '') + '</textarea></div>';
      } else {
        // #5/#6 placement preview + per-side upload, combined in one compact card each.
        html += '<p class="ti-cfg__mock-note">This shows placement only — we’ll send you a real proof of your artwork before anything prints.</p>';
        if (n === 2) {
          html += '<label class="ti-cfg__samecheck" style="margin-bottom:.75rem"><input type="checkbox" data-ti-same' + (state.sameArtwork ? ' checked' : '') + '> Use the same artwork on both sides</label>';
        }
        var artSides = (n === 2 && !state.sameArtwork) ? ['Front', 'Back'] : ['Front'];
        html += '<div class="ti-mock__row">' + artSides.map(function (sd, i) { return signMockupUploadCardHTML(sd, i); }).join('') + '</div>';
        html += '<div class="ti-cfg__field"><label>Production notes (optional)</label><textarea data-ti-notes rows="3" placeholder="Anything we should know?">' + (state.notes || '') + '</textarea></div>';
        html += '<p class="ti-cfg__helper">Need different designs on different signs? <a href="' + QUOTE_URL + '">Contact us.</a></p>';
      }

    } else if (s === 7) {
      html = '<h2 class="ti-cfg__h">Review your sign</h2>' +
        reviewRow('Size', state.size || (DATA.sizes && DATA.sizes.length ? '—' : 'quoted')) +
        reviewRow('Sides', state.sides || '—') +
        reviewRow('Colors', state.colors || '—') +
        reviewRow('Quantity', (state.qty || 0) + ' signs') +
        reviewRow('H-Stakes', String(state.stakes)) +
        artworkReviewRows() +
        // #5 design preview — placement only
        '<h3 class="ti-cfg__mock-title">Where your design will print</h3>' +
        '<p class="ti-cfg__mock-note">This shows placement only — we’ll send you a real proof of your artwork before anything prints.</p>' +
        signMockupsHTML();
      var p = unitPriceCents();
      var reason = quoteReason();
      // #4 No "how would you like to finish?" here — path is set at step 1; the order panel carries the action.
      if (hasPrice() && !reason && !state.designHelp && state.path !== 'quote') {
        html += reviewRow('Unit price', money(p) + ' / sign  (' + (state.qty || 0) + ' band)');
        if (state.stakes) html += reviewRow('H-Stakes price', money(stakesTotalCents()) + ' / ' + state.stakes + ' stakes');
        html += '<div class="ti-cfg__review-row is-total"><span>Total</span><span>' + money(orderTotalCents()) + '</span></div>';
      } else {
        // Route to quote (spec #13): out-of-band qty, design-help, or unpriced combo.
        var msg = reason || (state.designHelp
          ? 'We’ll design it for you and send a price before anything is printed.'
          : 'This combination is priced individually — we’ll get you an exact quote.');
        html += '<div class="ti-cfg__note">' + msg + ' Your selections are saved and sent straight to our team.</div>' +
          '<div class="ti-cfg__paths"><div class="ti-cfg__path"><b>Request a Quote →</b><br><small>We’ll confirm pricing for this sides / colours / quantity, then send a proof before printing.</small></div></div>';
      }
    }

    body.innerHTML = html;
    bind();
    updateSummary();
    if (s === 4) updateQtyNote();   // #1 show at-min/at-max message on arrival
    backBtn.style.visibility = s === 0 ? 'hidden' : 'visible';
    if (s === LAST_STEP) {
      var canBuy = hasPrice() && !quoteReason() && !state.designHelp && state.path !== 'quote';
      nextBtn.textContent = canBuy ? 'Add to Cart →' : 'Request a Quote →';
    } else nextBtn.textContent = 'Continue →';
    nextBtn.disabled = !canContinue();
  }

  // #5/#6 Sign design preview — placement only. 1 Sided → Front; 2 Sided → Front + Back.
  function signSides() { return sidesCount() === 2 ? ['Front', 'Back'] : ['Front']; }
  function signMockupCardHTML(side) {
    var img = DATA.signMockupUrl
      ? '<img src="' + DATA.signMockupUrl + '" alt="Sign ' + side + '">' : '';
    return '<figure class="ti-mock">' +
        '<div class="ti-mock__img">' + img + '</div>' +
        '<figcaption class="ti-mock__cap">' + side + '</figcaption>' +
      '</figure>';
  }
  function signMockupsHTML() {
    return '<div class="ti-mock__row">' + signSides().map(signMockupCardHTML).join('') + '</div>';
  }
  // Compact combined card for the artwork step: mockup + side label + that side's own upload.
  function signMockupUploadCardHTML(side, i) {
    var img = DATA.signMockupUrl ? '<img src="' + DATA.signMockupUrl + '" alt="Sign ' + side + '">' : '';
    var fn = state.artworkByside[side];
    var id = 'ti-sign-art-' + i;
    return '<figure class="ti-mock ti-mock--up">' +
        '<div class="ti-mock__img">' + img + '</div>' +
        '<figcaption class="ti-mock__cap">' + side + '</figcaption>' +
        '<label class="ti-cfg__upload ti-mock__up' + (fn ? ' is-filled' : '') + '" for="' + id + '">' +
          (fn ? '✓ ' + fn : '📎 Upload artwork') +
          '<input type="file" id="' + id + '" data-ti-file="' + side + '" accept=".png,.jpg,.jpeg,.avif,.heic,.pdf,image/png,image/jpeg,image/avif,image/heic,application/pdf" style="position:absolute;width:1px;height:1px;opacity:0;overflow:hidden"></label>' +
      '</figure>';
  }
  function reviewRow(k, v) { return '<div class="ti-cfg__review-row"><span>' + k + '</span><b>' + v + '</b></div>'; }
  function artworkReviewRows() {
    var n = sidesCount();
    if (n === 2 && state.sameArtwork) {
      return reviewRow('Artwork', (state.artworkByside.Front || 'send later') + ' (both sides)');
    }
    var rows = reviewRow('Artwork · Front', state.artworkByside.Front || 'send later');
    if (n === 2) rows += reviewRow('Artwork · Back', state.artworkByside.Back || 'send later');
    return rows;
  }

  function bind() {
    root.querySelectorAll('[data-path]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.path = el.getAttribute('data-path');
        if (state.path === 'quote') { window.location.href = QUOTE_URL; return; }
        render();
      });
    });
    root.querySelectorAll('[data-size]').forEach(function (el) {
      el.addEventListener('click', function () { state.size = el.getAttribute('data-size'); render(); });
    });
    root.querySelectorAll('[data-sides]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.sides = el.getAttribute('data-sides');
        // if the chosen color no longer pairs with the new sides, clear it
        if (state.colors && !COMBO[state.sides + '|' + state.colors]) state.colors = null;
        render();
      });
    });
    root.querySelectorAll('[data-colors]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.colors = el.getAttribute('data-colors');
        // #1 re-clamp when the print method changes (e.g. 100 spot → full colour drops to 25).
        if (state.qty) state.qty = clampQty(state.qty);
        render();
      });
    });
    var qtyInput = root.querySelector('[data-ti-qty]');
    if (qtyInput) {
      // Type freely; reflect in the panel + note live, but clamp on blur/change (spec #1).
      qtyInput.addEventListener('input', function () {
        state.qty = parseInt(qtyInput.value) || 0;
        updateSummary(); nextBtn.disabled = !canContinue();
        updateQtyNote();
      });
      var clampOnLeave = function () {
        var c = clampQty(parseInt(qtyInput.value) || 0);
        state.qty = c; qtyInput.value = c;
        updateSummary(); nextBtn.disabled = !canContinue(); updateQtyNote();
        // re-highlight the matching quick-pick
        root.querySelectorAll('[data-ti-pick]').forEach(function (b) {
          b.classList.toggle('is-sel', parseInt(b.getAttribute('data-ti-pick')) === c);
        });
      };
      qtyInput.addEventListener('blur', clampOnLeave);
      qtyInput.addEventListener('change', clampOnLeave);
    }
    root.querySelectorAll('[data-ti-pick]').forEach(function (el) {
      el.addEventListener('click', function () { state.qty = parseInt(el.getAttribute('data-ti-pick')); render(); });
    });
    root.querySelectorAll('[data-ti-stakes]').forEach(function (el) {
      el.addEventListener('click', function () {
        var q = Number(el.getAttribute('data-ti-stakes'));
        if (STAKES.indexOf(q) === -1) return;
        state.stakes = q;
        render();
      });
    });
    root.querySelectorAll('[data-ti-fin]').forEach(function (el) {
      el.addEventListener('change', function () {
        var f = el.getAttribute('data-ti-fin');
        var i = state.finishing.indexOf(f);
        if (el.checked && i === -1) state.finishing.push(f);
        else if (!el.checked && i !== -1) state.finishing.splice(i, 1);
        // "No finishing" is exclusive
        if (f.toLowerCase().indexOf('no finishing') === 0 && el.checked) state.finishing = [f];
        else if (el.checked) state.finishing = state.finishing.filter(function (x) { return x.toLowerCase().indexOf('no finishing') !== 0; });
        render();
      });
    });
    root.querySelectorAll('[data-ti-artmode]').forEach(function (el) {
      el.addEventListener('change', function () { state.designHelp = el.getAttribute('data-ti-artmode') === 'help'; render(); });
    });
    var same = root.querySelector('[data-ti-same]');
    if (same) same.addEventListener('change', function () { state.sameArtwork = same.checked; render(); });
    root.querySelectorAll('[data-ti-file]').forEach(function (fileInput) {
      fileInput.addEventListener('change', function () {
        var side = fileInput.getAttribute('data-ti-file');
        var f = fileInput.files && fileInput.files[0];
        if (f) { state.artworkByside[side] = f.name; state.artworkFileBySide[side] = f; render(); }
      });
    });
    var notes = root.querySelector('[data-ti-notes]');
    if (notes) notes.addEventListener('input', function () { state.notes = notes.value; });

    root.querySelectorAll('[data-review-path]').forEach(function (el) {
      el.addEventListener('click', function () { state.path = el.getAttribute('data-review-path'); render(); });
    });
  }

  function updateSummary() {
    var lines = [];
    if (state.size) lines.push(['Size', state.size]);
    if (state.sides) lines.push(['Sides', state.sides]);
    if (state.colors) lines.push(['Colors', state.colors]);
    if (state.qty) lines.push(['Quantity', state.qty + ' signs']);
    if (state.stakes) lines.push(['H-Stakes', String(state.stakes)]);
    if (state.finishing.length) lines.push(['Finishing', state.finishing.length + ' selected']);
    root.querySelector('[data-ti-sumlines]').innerHTML = lines.map(function (l) {
      return '<div class="ti-cfg__sumline"><span class="k">' + l[0] + '</span><span class="v">' + l[1] + '</span></div>';
    }).join('') || '<div class="ti-cfg__est">Start selecting options…</div>';
    // Quote paths (out-of-band qty, design-help, unpriced combo) show "Quote", not $0.00.
    var needsQuote = quoteReason() || state.designHelp || (state.colors && !hasPrice() && state.qty > 0);
    root.querySelector('[data-ti-total]').textContent = needsQuote ? 'Quote' : money(orderTotalCents());
    // #8: prices are exact catalog values now — drop the "estimated" note once a real price shows.
    if (estEl) estEl.hidden = hasPrice();
    var mapEl = root.querySelector('[data-ti-map]');
    var combined = combinedValue();
    if (combined) mapEl.innerHTML = 'Maps to variant: <code>' + combined + '</code>';
    else mapEl.innerHTML = '';
  }

  function canContinue() {
    var s = state.step;
    if (s === 0) return state.path === 'standard';
    if (s === 1) return (DATA.sizes && DATA.sizes.length) ? !!state.size : true; // no sizes → quote-style, allow through
    if (s === 2) return !!state.sides;
    if (s === 3) return !!state.colors;
    if (s === 4) return (state.qty || 0) > 0;
    if (s === 5) return true; // finishing optional
    if (s === 6) return true; // artwork optional — send later never blocks
    return true;
  }

  function addToCart() {
    var v = variant();
    var combined = combinedValue();
    var reason = quoteReason();
    // Route to quote when: no price/variant, out-of-band qty, design-help, or user chose quote (spec #13).
    if (!v || !hasPrice() || reason || state.designHelp || state.path === 'quote') {
      var n0 = sidesCount();
      var art = state.designHelp ? 'Design help requested'
        : (n0 === 2 && state.sameArtwork)
          ? ((state.artworkByside.Front || 'send later') + ' (both sides)')
          : [(state.artworkByside.Front ? 'Front: ' + state.artworkByside.Front : ''), (n0 === 2 && state.artworkByside.Back ? 'Back: ' + state.artworkByside.Back : '')].filter(Boolean).join(' · ');
      var q = {
        product: DATA.productTitle || '',
        type: 'Custom sign',
        sides: state.sides || '',
        colors: state.colors || '',
        qty: state.qty || '',
        finishing: state.finishing.concat(state.stakes ? [stakesDescription()] : []).join(', '),
        artwork: art,
        reason: reason || (state.designHelp ? 'Needs design help' : ''),
        notes: state.notes || ''
      };
      var params = Object.keys(q).filter(function (k) { return q[k] !== '' && q[k] != null; })
        .map(function (k) { return k + '=' + encodeURIComponent(q[k]); }).join('&');
      window.location.href = QUOTE_URL + (QUOTE_URL.indexOf('?') === -1 ? '?' : '&') + params;
      return;
    }
    var n = sidesCount();
    var props = {
      'Size': state.size || '—',
      'Sides': state.sides || '—',
      'Colors': state.colors || '—',
      'Quantity': String(state.qty || 0),
      'Finishing': state.finishing.length ? state.finishing.join(', ') : 'None',
      'H-stakes': stakesDescription(),
      'Notes': state.notes || ''
    };
    if (n === 2 && state.sameArtwork) {
      props['Artwork'] = (state.artworkByside.Front || 'send later') + ' (both sides)';
    } else {
      props['Artwork · Front'] = state.artworkByside.Front || 'send later';
      if (n === 2) props['Artwork · Back'] = state.artworkByside.Back || 'send later';
    }
    nextBtn.disabled = true; nextBtn.textContent = 'Adding…';
    var items = [{ id: v.id, quantity: state.qty, properties: props }];
    var checkStakes = Promise.resolve();
    if (state.stakes) {
      var pack = stakesPack();
      var group = 'sign-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      props._sign_order = group;
      items.push({ id: pack.id, quantity: stakesPacksCount(), properties: {
        'For': DATA.productTitle || 'Custom sign',
        'H-stakes total': String(state.stakes),
        '_sign_order': group
      } });
      checkStakes = fetch('/products/h-stakes.js').then(function (r) {
        if (!r.ok) throw new Error('H-stakes unavailable');
        return r.json();
      }).then(function (product) {
        var live = (product.variants || []).find(function (item) { return item.id === pack.id; });
        if (!live || !live.available || live.price !== pack.price) throw new Error('H-stakes unavailable or price changed');
      });
    }
    checkStakes.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('Could not add order');
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      nextBtn.disabled = false; nextBtn.textContent = 'Add to Cart →';
      alert('Could not add to cart. Please try again.');
    });
  }

  nextBtn.addEventListener('click', function () {
    if (state.step < LAST_STEP) { state.step++; render(); }
    else { addToCart(); }
  });
  backBtn.addEventListener('click', function () { if (state.step > 0) { state.step--; render(); } });

  // #2 Clickable step bar — jump to any reached step; keyboard-activatable.
  function stepJump(el) {
    var i = parseInt(el.getAttribute('data-step'));
    if (isNaN(i) || i > furthest || i === state.step) return;
    state.step = i; render();
    body.scrollIntoView({ behavior: 'smooth', block: 'start' });   // #2 scroll panel into view
  }
  Array.prototype.forEach.call(stepsEl.children, function (el) {
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.addEventListener('click', function () { stepJump(el); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stepJump(el); }
    });
  });

  // Load ALL variants (Liquid caps at 250) via the product JSON endpoint.
  fetch('/products/' + DATA.handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      DATA.variants = (p.variants || []).map(function (v) {
        return { id: v.id, price: v.price, available: v.available, options: v.options, image: v.featured_image ? v.featured_image.src : null };
      });
      // Prefer the live product's real print values if present (self-corrects to reality).
      if (p.options) {
        var po = p.options.find(function (o) { return (o.name || '').toLowerCase().indexOf('size') === -1; });
        if (po && po.values && po.values.length) DATA.prints = po.values;
      }
      buildLookup();
      render();
    })
    .catch(function () { buildLookup(); render(); });
})();
